import { render, staticRenderFns } from "./ArmariosDrawer.vue?vue&type=template&id=07e36d3a&scoped=true"
import script from "./ArmariosDrawer.vue?vue&type=script&lang=js"
export * from "./ArmariosDrawer.vue?vue&type=script&lang=js"
import style0 from "./ArmariosDrawer.vue?vue&type=style&index=0&id=07e36d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e36d3a",
  null
  
)

export default component.exports